import { NAME } from './constants';

export const REQUEST_REGISTRY_ENTRY_SEARCH = `${NAME}/requestRegistryEntrySearch`;
export const RECEIVE_REGISTRY_ENTRY_SEARCH = `${NAME}/receiveRegistryEntrySearch`;
export const CHANGE_REGISTRY_ENTRIES_VIEW_MODE = `${NAME}/changeRegistryEntriesViewMode`;

export const SET_QUERY_PARAMS = `${NAME}/setQueryParams`;
export const RESET_QUERY = `${NAME}/resetQuery`;
